<template>
  <div>
    <div class="app-content--inner p-0">
      <page-title
        class="custom-breadcrumb"
        heading="Tambah Obat"
        :breadcrumb="[
          {
            label: 'Manajemen Obat & BHP',
            link: '/klinik/obat'
          },
          {
            label: 'Tambah Obat & BHP',
            active: true,
          }
        ]"
      />
      <div class="container-fluid __zoom_out_obat">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-box mb-5">
              <div class="card-body p-5" style="padding-top:0px">
                <b-form @submit.prevent="submitinputObat">
                  <b-row
                    v-for="(inputObat, index) in tmpInputObatData"
                    :key="inputObat.id"
                  >
                    <b-col sm="11 outer-obat-tambah" :class="{'mt-5': index > 0}">
                      <b-row>
                        <b-col sm="6">
                          <!-- kode obat -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Kode Obat <span style="color:red">*</span></label
                            >
                            <b-form-input
                              :value="inputObat.kode_layanan"
                              @change="
                                onChangeValue({
                                  label: 'kode_layanan',
                                  index,
                                  $event
                                })
                              "
                              style="padding-right : 30px"
                              @input="
                                onInputKode(
                                  $event,
                                  index,
                                  inputObat,
                                  'kode_layanan'
                                )
                              "
                              :state="
                                errorState({ label: 'kode_layanan', index })
                              "
                              maxlength="10"
                              class="col-md-7 pl-2"
                              placeholder="input kode obat"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              class="ml-1"
                            >
                              {{
                                inputObat.error &&
                                inputObat.error.kode_layanan.desc ==
                                  "kode layanan harus diisi"
                                  ? "Kode obat harus diisi"
                                  : inputObat.error.kode_layanan.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- nama obat -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Nama Obat <span style="color:red">*</span></label
                            >
                            <b-form-input
                              :value="inputObat.nama_layanan"
                              @change="
                                onChangeValue({
                                  label: 'nama_layanan',
                                  index,
                                  $event
                                })
                              "
                              style="padding-right : 30px"
                              @input="
                                onInputNamaLayanan(
                                  $event,
                                  index,
                                  inputObat,
                                  'nama_layanan'
                                )
                              "
                              :state="
                                errorState({ label: 'nama_layanan', index })
                              "
                              maxlength="100"
                              class="col-md-7 pl-2"
                              placeholder="input nama obat"
                            ></b-form-input>
                            <b-form-invalid-feedback
                              class="ml-1"
                            >
                              {{
                                inputObat.error &&
                                inputObat.error.nama_layanan.desc ==
                                  "nama layanan harus diisi"
                                  ? "Nama obat harus diisi"
                                  : inputObat.error.nama_layanan.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- kategori -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Kategori
                              <span style="color:red" class="mr-2">*</span>
                              <font-awesome-icon
                                v-tooltip="{
                                  content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui Kategori obat </span><br/>`
                                }"
                                class="tooltip-obat"
                                icon="info-circle"
                              />
                            </label>
                            <vue-select
                              style="font-size:13px"
                              :options="optKategori"
                              @input="inputKategori($event, index)"
                              v-model="tmpInputObatData[index].kategori_obat"
                              class="form-select-tarif col-md-7 p-0"
                              placeholder="pilih kategori"
                            />
                            <b-form-invalid-feedback class="ml-1">
                              {{
                                inputObat.error &&
                                  inputObat.error.kategori_obat_id.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- jenis -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Jenis
                              <span style="color:red" class="mr-2">*</span>
                              <font-awesome-icon
                                v-tooltip="{
                                  content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui jenis obat </span><br/>`
                                }"
                                class=" tooltip-obat"
                                style="margin-left:20px"
                                icon="info-circle"
                              />
                            </label>
                            <vue-select
                              style="font-size:13px;height:auto;"
                              :options="optJenis"
                              @input="inputJenis($event, index)"
                              v-model="inputObat.jns_obat"
                              class="form-select-tarif col-md-7 p-0"
                              placeholder="pilih jenis obat"
                            />
                            <b-form-invalid-feedback class="ml-1">
                              {{
                                inputObat.error &&
                                  inputObat.error.jns_obat_id.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form>
                        </b-col>
                        <b-col sm="6">
                          <!-- harga -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Harga <span style="color:red">*</span></label
                            >
                            <b-form-input
                              @input="inputObatLayanan($event, index)"
                              v-model.lazy="inputObat.tarif"
                              v-money="money"
                              :state="errorState({ label: 'tarif', index })"
                              maxlength="19"
                              class="col-md-7"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback class="ml-1">
                              {{
                                inputObat.error && inputObat.error.tarif.desc
                              }}
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- stok -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Stok</label
                            >
                            <b-form-input
                              :value="inputObat.stok"
                              @change="
                                onChangeValue({
                                  label: 'stok',
                                  index,
                                  $event
                                })
                              "
                              style="padding-right : 30px"
                              v-on:keypress="NumbersOnly"
                              maxlength="100"
                              class="col-md-7 pl-2"
                              placeholder="input stok"
                            ></b-form-input>
                            <b-form-invalid-feedback class="ml-1">
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- Satuan -->
                          <b-form inline>
                            <label
                              class="col-md-3"
                              style="font-size: 13px;padding:5px;"
                              >Satuan
                            </label>
                            <vue-select
                              style="font-size:13px"
                              :options="optSatuan"
                              @input="inputSatuan($event, index)"
                              v-model="tmpInputObatData[index].satuan"
                              class="form-select-tarif col-md-7 p-0"
                              placeholder="pilih satuan"
                            />
                            <b-form-invalid-feedback class="ml-1">
                            </b-form-invalid-feedback>
                          </b-form>
                          <!-- catatan -->
                          <b-form inline style="align-items:baseline;">
                            <label
                              class="col-md-3 mt-0"
                              style="font-size: 13px;padding:5px;"
                              >Catatan</label
                            >
                              <b-form-textarea
                                class="col-md-8"
                                rows="4" no-resize
                                v-model="inputObat.note"
                                @change="
                                  onChangeValue({
                                    label: 'note',
                                    index,
                                    $event
                                  })
                                "
                                placeholder="input catatan pendukung.
Contoh: Masa berlaku obat
20 September 2025, pembelian batch 1."
                              ></b-form-textarea>
                          </b-form>
                        </b-col>
                      </b-row>
                    </b-col>
                    <!-- action minus -->
                    <b-col sm="1" style="margin-top: 125px;">
                      <div align="right">
                        <b-button
                          variant="danger"
                          :style="btnRemoveMobileStyle"
                          @click="removeinputObatData(index)"
                          v-if="index > 0"
                        >
                          <font-awesome-icon icon="minus" class="fa-sm" />
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-center ">
                    <b-col lg="11 p-0">
                      <div class="d-flex justify-content-center mt-4">
                        <b-button
                          variant="first"
                          class="mr-3"
                          style="padding: .5rem .8rem; border-radius: 100%"
                          @click="addinputObatData"
                        >
                          <font-awesome-icon icon="plus" />
                        </b-button>
                      </div>
                      <div align="right">
                        <b-button
                          class="text-capitalize mr-2"
                          variant="danger"
                          :to="{ path: '/klinik/obat' }"
                          >keluar</b-button
                        >
                        <b-button
                          class="text-capitalize"
                          type="submit"
                          variant="primary"
                          >simpan</b-button
                        >
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";
import { VMoney } from "v-money";
library.add(faPlus, faMinus, faInfoCircle);

export default {
  directives: {
    money: VMoney
  },
  components: {
    "vue-select": () => import("@/components/VueSelect.vue")
  },
  data: () => ({
    money: {
      decimal: "",
      thousands: ",",
      prefix: "Rp. ",
      suffix: "",
      precision: 0
    },
    beingSubmit: false,
    errorKodeLayanan: null,
    errorsKodeLayanan: [],
    tmpInputObatData: [
      {
        status: true,
        jns_obat: null,
        jns_obat_id: null,
        kategori_obat: null,
        kategori_obat_id: null,
        nama_layanan: null,
        kode_layanan: null,
        tarif: null,
        selectedKelompok: "Obat",
        stok: null,
        satuan: null,
        satuan_id: null,
        note: null,
      }
    ],
    optKategori: [],
    optSatuan: [],
    optJenis: [],
    selectedKategori: null,
    selectedJenis: null,
    kodeContainer: [],
    namaContainer: [],
    beingSubmit: false,
    namaLayananContainer: [],
    kodeLayananContainer: [],
    errorKodeLayanan: null,
    errorsKodeLayanan: [],
    kodeLayananExistsInDb: [],
    namaLayananExistsInDb: []
  }),
  computed: {
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    },
    ...mapGetters(["getKlinikId"])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  beforeMount() {
    this.tmpInputObatData = this.settmpInputObatData();
  },
  mounted() {
    this.getKategori();
    this.getJenis();
    this.getSatuan();
  },
  methods: {
    inputObatLayanan(data, index) {
      if (data != "Rp. 0") {
        this.tmpInputObatData[index].error.tarif.error = true;
        this.tmpInputObatData[index].error.tarif.desc = "";
      } else if (
        this.tmpInputObatData[index].nama_layanan != null &&
        this.tmpInputObatData[index].kode_layanan != null &&
        data == "Rp. 0"
      ) {
        this.tmpInputObatData[index].error.tarif.error = true;
        this.tmpInputObatData[index].error.tarif.desc = "";
      }
    },
    async getJenis() {
      try {
        const res = await this.$axios.get(`klinik/obat/jenis`);
        const { data, status } = res.data;
        if (status) {
          this.optJenis = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`klinik/obat/kategori`);
        const { data, status } = res.data;
        if (status) {
          this.optKategori = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    inputKategori(data, index) {
      this.tmpInputObatData[index].kategori_obat_id = this.tmpInputObatData[index].kategori_obat.value;
      if (this.tmpInputObatData[index].kategori_obat_id != null) {
        this.tmpInputObatData[index].error.kategori_obat_id.error = true;
        this.tmpInputObatData[index].error.kategori_obat_id.desc = "";
      }
    },
    inputSatuan(data, index) {
      this.tmpInputObatData[index].satuan_id = this.tmpInputObatData[index].satuan.value;
    },
    inputJenis(data, index) {
      this.tmpInputObatData[index].jns_obat_id = this.tmpInputObatData[index].jns_obat.value;
      if (this.tmpInputObatData[index].jns_obat_id != null) {
        this.tmpInputObatData[index].error.jns_obat_id.error = true;
        this.tmpInputObatData[index].error.jns_obat_id.desc = "";
      }
    },
    settmpInputObatData() {
      return this.tmpInputObatData.map(item => {
        const tmp = Object.keys(item).reduce((obj, key) => {
          if (key !== "error") {
            obj[key] = this.generateErrorObj();
          }
          return obj;
        }, {});
        return {
          ...item,
          error: tmp
        };
      });
    },
    generateErrorObj() {
      return {
        error: null,
        desc: null
      };
    },
    errorState({ label, index }) {
      const { tmpInputObatData } = this;
      if (
        tmpInputObatData[index].error &&
        tmpInputObatData[index].error[label]
      ) {
        return tmpInputObatData[index].error[label].error;
      } else {
        return null;
      }
    },
    errorDesc({ label, index }) {
      const { tmpInputObatData } = this;
      if (
        tmpInputObatData[index].error &&
        tmpInputObatData[index].error[label]
      ) {
        return tmpInputObatData[index].error[label].desc;
      }
    },
    onKeyupTarif($event, index) {
      const { tmpInputObatData } = this;

      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    placeholderInput(label = "") {
      return startCase(`input ${label}`);
    },
    validateInput({ label, $event }) {
      return {
        error: ($event && true) || false,
        desc: (!$event && "kolom harus diisi") || ""
      };
    },
    validateAll() {
      const valItems = [
        "jns_obat_id",
        "kategori_obat_id",
        "kode_layanan",
        "nama_layanan",
        "tarif"
      ];

      this.tmpInputObatData.forEach(item => {
        valItems.forEach(valItem => {
          if (item.error[valItem].error == false) return;

          if (!item[valItem]) {
            item.error[valItem].error = false;
            item.error[valItem].desc =
              valItem.replace("_", " ") + " harus diisi";
            if (
              item.error[valItem].desc == "kategori obat_id harus diisi" ||
              item.error[valItem].desc == "jns obat_id harus diisi"
            ) {
              let keynya = valItem.replace("_obat_id", " ");

              if (/kategori/.test(keynya)) {
                item.error[valItem].desc = "Kategori harus dipilih";
              } else {
                item.error[valItem].desc = "Jenis harus dipilih";
              }
            }
          } else {
            item.error[valItem].error = true;
            item.error[valItem].desc = "";
          }
        });
      });
    },
    submitinputObat() {
      const { tmpInputObatData, validateAll } = this;
      this.$nextTick(() => {
        validateAll();

        let isError = false;

        tmpInputObatData.forEach(tarifData => {
          for (let errIndex in tarifData.error) {
            if (tarifData.error[errIndex].error == false) {
              isError = true;
            }
          }
        });

        if (isError == false) {
          this.doSubmitinputObat();
        } else {
          this.$swal({
            type: "warning",
            text: "Silakan cek kembali pengisian data Anda!"
          });
        }
      });
    },
    async doSubmitinputObat() {
      const { constructPostData } = this;

      try {
        const res = await this.$axios.post(`klinik/obat`, {
          klinik_id: this.getKlinikId,
          arr: constructPostData()
        });
        const { status, data } = res.data;
        this.beingSubmit = true;
        this.$swal({
          title: "Tambah Data Berhasil",
          text: "Data berhasil tersimpan",
          icon: "success",
          confirmButtonText: startCase("ya")
        });
        this.$router.push({ path: "/klinik/obat" });
      } catch (errror) {
        const x = errror.response.data;
        const y = Object.keys(x);
        y.map(item => {
          const z = item.split(".");
          this.tmpInputObatData[z[1]].error.nama_layanan.desc =
            x[item][x[item].length - x[item].length];
        });
        var d = errror.response.data.length;
      }
    },
    constructPostData() {
      const { tmpInputObatData } = this;
      const tmp = tmpInputObatData.map(item => {
        const x = Object.keys(item).filter(y => !["error"].includes(y));
        const z = x.reduce((obj, key) => {
          let q = key;

          if (key == "tarif") {
            q = "tarif";
            // hapus separator ribuan dan jadikan int
            item[key] = parseInt(item[key].replace(/\D/g, ""));
          }

          if (key == "stok") {
            if(item[key] != null){
              item[key] = parseInt(item[key])
            }
          }

          obj[q] = item[key];
          return obj;
        }, {});
        z.klinik_id = this.getKlinikId;
        return z;
      });
      return tmp;
    },
    onChangeValue({ index, label, $event }) {
      const { tmpInputObatData, validateInput } = this;
      const tmp = tmpInputObatData[index];
      if (tmp.error[label].error !== false) {
        tmp.error[label] = validateInput({
          label,
          $event
        });
      }
      if (label !== "tarif") {
        tmp[label] = $event;
        Vue.set(this.tmpInputObatData, index, tmp);
      }
    },
    onInputNamaLayanan(valRaw, index, o, p) {
      if (this._timeoutNamaLayanan) clearTimeout(this._timeoutNamaLayanan);
      let val = valRaw;
      Vue.set(o, p, valRaw);
      Vue.set(this.namaLayananContainer, index, val);

      if (!val) {
        this.tmpInputObatData[index].error["nama_layanan"].error = false;
        this.tmpInputObatData[index].error["nama_layanan"].desc =
          "Nama obat harus diisi";
        return;
      } else {
        this.tmpInputObatData[index].error["nama_layanan"].error = true;
        this.tmpInputObatData[index].error["nama_layanan"].desc = "";
      }
    },
    onInputKode(val, index, o, p) {
      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);
      val = val.toUpperCase();
      Vue.set(o, p, val);
      Vue.set(this.kodeLayananContainer, index, val);

      if (val.match(/[^a-zA-Z0-9\-]+/) !== null) {
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Hanya bisa huruf, angka, dan -";
        return;
      }

      if (val.length == 0){
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Kode obat harus diisi";
        return;
      }

      if (val.length < 3 && val.length > 0) {
        this.tmpInputObatData[index].error["kode_layanan"].error = false;
        this.tmpInputObatData[index].error["kode_layanan"].desc =
          "Kode obat minimal 3 karakter";
        return;
      }

      let isDuplicate = false;
      let needDbChecks = [];
      this.kodeLayananContainer.forEach((item, i) => {
        isDuplicate = false;
        this.kodeLayananContainer.forEach((item2, i2) => {
          if (i != i2) {
            if (item == item2 && item !== "") {
              this.tmpInputObatData[i].error["kode_layanan"].error = false;
              this.tmpInputObatData[i].error["kode_layanan"].desc =
                "Kode obat tidak boleh sama";

              isDuplicate = true;
            }
          }
        });
        if (isDuplicate == false) {
          this.tmpInputObatData[i].error["kode_layanan"].error = true;
          this.tmpInputObatData[i].error["kode_layanan"].desc = "";

          needDbChecks.push(i);
        }
      });

      if (needDbChecks.length > 0) {
        let newNeedDbChecks = [];
        needDbChecks.forEach(item => {
          let valDb = this.tmpInputObatData[item].kode_layanan;
          if (this.kodeLayananExistsInDb.indexOf(valDb) > -1) {
            this.tmpInputObatData[item].error["kode_layanan"].error = false;
            this.tmpInputObatData[item].error["kode_layanan"].desc =
              "Kode obat tidak boleh sama";
          } else newNeedDbChecks.push(item);
        });
        needDbChecks = newNeedDbChecks;

        this._timeoutKodeLayanan = setTimeout(() => {
          needDbChecks.forEach(item => {
            this.$axios
              .post(
                `klinik/obat/cek?klinik_id=${this.getKlinikId}&kode_layanan=${this.tmpInputObatData[item].kode_layanan}`
              )
              .then(response => {
                if (response.data.status == false) {
                  this.tmpInputObatData[item].error[
                    "kode_layanan"
                  ].error = false;
                  this.tmpInputObatData[item].error["kode_layanan"].desc =
                    "Kode obat tidak boleh sama";
                }
              })
              .catch(error => {})
              .finally(() => {
                clearTimeout(this._timeoutKodeLayanan);
              });
          });
        }, 600);
      }
    },
    addinputObatData() {
      const { tmpInputObatData, validateAll, generateErrorObj } = this;
      const lastIndex = tmpInputObatData[tmpInputObatData.length - 1];
      if (lastIndex === undefined) {
        this.tmpInputObatData.push({
          status: true,
          jns_obat: null,
          jns_obat_id: null,
          kategori_obat: null,
          kategori_obat_id: null,
          nama_layanan: null,
          kode_layanan: null,
          tarif: null,
          selectedKelompok: "Obat",
          stok: null,
          satuan: null,
          satuan_id: null,
          note: null,
        })
        this.tmpInputObatData = this.settmpInputObatData();
      } else {
        const x = Object.keys(lastIndex);
        const tmp = x.reduce((obj, key) => {
          if (key === "error") {
            obj[key] = x
              .filter(item => item !== "error")
              .reduce((obj, keyChild) => {
                obj[keyChild] = generateErrorObj();
                return obj;
              }, {});
          } else if (key === "id") {
            obj[key] = tmpInputObatData.length + 1;
          } else if (key == "status") {
            obj[key] = true;
          } else if (key == "selectedKelompok") {
            obj[key] = "Obat";
          } else {
            obj[key] = null;
          }
          return obj;
        }, {});
        validateAll();
        this.tmpInputObatData = [...tmpInputObatData, tmp];
      }
    },
    removeinputObatData(index) {
      const { tmpInputObatData } = this;
      const tmp = tmpInputObatData
        .slice(0, index)
        .concat(tmpInputObatData.slice(index + 1, tmpInputObatData.length));
      this.tmpInputObatData = tmp;

      // remap kodeLayananContainer
      this.kodeLayananContainer = tmp.map(item => {
        return item.kode_layanan;
      });
      this.namaLayananContainer = tmp.map(item => {
        return item.nama_layanan;
      });

      this.tmpInputObatData.forEach((v, i) => {
        if (v.kode_layanan != null && v.kode_layanan != "")
          this.onInputKode(v.kode_layanan, i, v, "kode_layanan");
        this.validateAll();
      });
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="scss">
.__zoom_out_obat {
  zoom: 80%;
}

.tooltip {
  display: block !important;
  z-index: 10000;
  zoom: 80%;
}

.tooltip .tooltip-inner {
  background: rgb(255, 255, 255);
  color: black;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
  border-style: solid;
}

.tooltip .tooltip-arrow {
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.outer-obat-tambah {
  position: relative;
  border-radius: 15px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-select-tarif
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
}

.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}
</style>

<style lang="scss" scoped>
.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  margin-left: 150px !important;
  min-height: 18px;
  display: block;
}
</style>
